/**
 * Product Selector Quote Form - Dynamic Load
 * Responsible for determining if the PS Quote Form needs to load, and for actually loading the files.
 * @author Rhys Lloyd
 */

//
// Utilities

//
// Dependencies
import * as registry from '@core/registry';

//
// Constants
export const MODULE_NAME = registry.PS_QUOTE_FORM_MODULE;
export const MODULE_SELECTOR = '[data-ps-qf]';
export const ASSETS = [
	'../scripts/core-ps-quote-form.module.js'
];

//
// Load
export default function load() {
	registry.dynamicLoader(MODULE_NAME, MODULE_SELECTOR, ASSETS);
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/ps-quote-form/dynamic-load.js